import {observable} from 'mobx';
import {awaitingAcquisitionsUrl, inAcquisitionsUrl, plannedAcquisitionUrl} from './APIEndpoints';
import {appStore} from './AppStore';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

class LooseLeafListStore {
    @observable listState = PENDING;
    @observable activeSeeds = [];
    @observable awaitingSeeds = [];
    @observable plannedSeeds = [];

    constructor() {
        this.apiProxy = appStore.apiProxy;
    }

    fetchActive = async () => {
        this.listState = PENDING;
        try {
            const response = await this.apiProxy.getAsync(inAcquisitionsUrl);
            this.activeSeeds = await response.json();
            this.listState = DONE;
        } catch (e) {
            this.listState = ERROR;
        }
    };

    fetchAwaiting = async () => {
        this.listState = PENDING;
        try {
            const response = await this.apiProxy.getAsync(awaitingAcquisitionsUrl);
            this.awaitingSeeds = await response.json();
            this.listState = DONE;
        } catch (e) {
            this.listState = ERROR;
        }
    };

    fetchPlanned = async () => {
        this.listState = PENDING;
        try {
            const response = await this.apiProxy.getAsync(plannedAcquisitionUrl);
            this.plannedSeeds = await response.json();
            this.listState = DONE;
        } catch (e) {
            this.listState = ERROR;
        }
    };

    updateRowData(rowIndex, newData, oldData) {
        this.awaitingSeeds[rowIndex] = {...oldData, ...newData};
    }

    removeRowData(rowIndex) {
        this.awaitingSeeds.splice(rowIndex, 1);
    }
}

export default new LooseLeafListStore();
